/**
 * Evaluate a conditional-logic operation, including GPACL's inclusive operators.
 *
 * Gravity Forms does not natively evaluate `>=` or `<=`. Expressing each as
 * its native strict comparison OR equality keeps every GPACL evaluation path
 * aligned with Gravity Forms' comparison semantics.
 *
 * @package
 */

/** Maps each inclusive operator to the Gravity Forms operator it extends. */
const INCLUSIVE_OPERATOR_MAP: Record<string, '>' | '<'> = {
	'>=': '>',
	'<=': '<',
};

/**
 * Evaluate an operation with the supplied Gravity Forms comparison callback.
 *
 * @param operator The conditional-logic operator.
 * @param matches  Callback that evaluates one native Gravity Forms operator.
 */
export function matchesConditionalOperation(
	operator: string,
	matches: (operator: string) => boolean
): boolean {
	const comparison = INCLUSIVE_OPERATOR_MAP[operator];

	if (!comparison) {
		return matches(operator);
	}

	return matches(comparison) || matches('is');
}
